import * as _ from 'lodash';

/**
 * Auto Answers Questions model
 * @param chatId
 *  <fields>
 <field name="AutoAnswersQuestionID" type="long" generateIfNull="true"/>
 <field name="AccountID" type="long" useAccountIDIfNull="true"/>
 <field name="RelatedToID" type="long"/>
 <field name="ServiceType" type="byte"/>
 <field name="Text" type="text"/>
 <field name="LanguageCode" type="text" size="2" default="en"/>
 <field name="Created" type="created"/>
 * </fields>
 *
 * @constructor
 */

export class AutoAnswersQuestions {
  static comparator(aaQuestion1, aaQuestion2) {
    return aaQuestion1.AutoAnswersQuestionID === aaQuestion2.AutoAnswersQuestionID;
  }

  static wrap(event) {
    return new AutoAnswersQuestions(event.data);
  }

  constructor(autoAnswersQuestionsRecord) {
    _.assign(this, autoAnswersQuestionsRecord);
  }
}
